export default "__VITE_ASSET__DOeGycpR__"